import { flatMap, sumBy, values } from 'lodash'

export function getAttachmentCount(details: Gravitate.OrderMovementDetails | undefined) {
  if (!details) return { dropImageCount: 0, bolImageCount: 0 }
  const dropsCount = sumBy(flatMap(details.delivery_attachments, values), 'length')
  const bolsCount = sumBy(details?.bols, (bol) => bol.photos?.length || 0)

  return {
    dropImageCount: dropsCount,
    bolImageCount: bolsCount,
  }
}
